document.addEventListener('DOMContentLoaded', () => {

  // HEADER GLASS EFFECT
  const header = document.querySelector('[data-pp-header]');

  const updateHeader = () => {
    if (!header) return;

    if (window.scrollY > 40) {
      header.classList.add('pp-scrolled');
    } else {
      header.classList.remove('pp-scrolled');
    }
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader);


  // HERO PARALLAX
  const heroBg = document.querySelector('.pp-hero-bg');
  const heroFlag = document.querySelector('.pp-hero-flag');

  const updateParallax = () => {
    const y = window.scrollY;

    if (heroBg) {
      heroBg.style.transform = `translateY(${y * 0.24}px)`;
    }

    if (heroFlag) {
      heroFlag.style.transform = `translateY(${y * 0.12}px)`;
    }
  };

  window.addEventListener('scroll', updateParallax);


  // FADE-IN REVEALS
  const revealItems = document.querySelectorAll('.pp-reveal');

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('pp-visible');
      }
    });
  }, {
    threshold: 0.12
  });

  revealItems.forEach(item => {
    revealObserver.observe(item);
  });


  // SMOOTH SCROLL BUTTONS
  document.querySelectorAll('[data-pp-scroll]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const targetId = button.getAttribute('data-pp-scroll');
      const target = document.querySelector(targetId);

      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });


  // MOBILE MENU
  const menuButton = document.querySelector('.pp-mobile-toggle');
  const mobileMenu = document.querySelector('.pp-mobile-menu');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('pp-open');
      menuButton.classList.toggle('pp-open');
    });
  }


  // ACTIVE ATMOSPHERE
  document.documentElement.classList.add('pp-loaded');

});